import { Component, Inject, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrderItem } from '../models/order-item';
import { CartService } from 'ng-shopping-cart';
import { ActivatedRoute } from '@angular/router';
import { Tenant } from '../models/tenant';
import { Invoice } from '../models/invoice';
import { InvoiceService } from '../services/data.invoice';
import { TenantService } from '../services/data.tenant';
import { Order_Dto, Order_Item_Dto } from '../models/order-dto';
import { LocaleFormat } from 'ng-shopping-cart';
import { Business } from '../models/business';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html'
})
export class InvoiceComponent implements OnInit {
  public invoice: Invoice;
  public items: TempItem[];
  private h: HttpClient;
  public business: Business;

  public cost: number;
  public today: number;
  public orderDeliveryInstructions: string;
  @Input() localeFormat: string;
  format: LocaleFormat;

  constructor(private invoiceService: InvoiceService, private route: ActivatedRoute, http: HttpClient, @Inject('BASE_URL') baseUrl: string, private cartService: CartService<OrderItem>) {
    this.h = http;
    this.business = new Business();
    this.today = Date.now();
    this.invoiceService.currentInvoice.subscribe(invoice => this.invoice = invoice);
    //    this.invoice = invoiceService.currentInvoice;
    const code = this.route.snapshot.paramMap.get('code');
    if (!this.localeFormat) {
      this.format = <LocaleFormat>this.cartService.getLocaleFormat(true);
    }

    this.h = http;
    this.orderDeliveryInstructions = "Orders will be delivered in the concession area at University of Akron on October 12th, 2019";
  }

  ngOnInit() {
    
  }
}

export class TempItem {
  public name: string;
  public quantity: number;
  public size: string;
  public price : number;
}



// WEBPACK FOOTER //
// ./src/app/invoice/invoice.component.ts